import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ConfiguracionRlt, DiaSemana } from '../models/configuracion-rlt';
import { DatosConfiguracionAplicacionService } from '../services/datos-configuracion-aplicacion.service';
import { TipoEnvio } from '../../Envios/envios/models/tipo-envio';
import { DatosEnviosService } from '../../Envios/envios/services/datos-envios.service';
import { ModalMessageComponent } from 'src/app/shared/components/modals/modal-message/modal-message.component';
import { MatDialog } from '@angular/material/dialog';
import { ValidacionesFormularioRltService } from '../services/validaciones-formulario-rlt.service';
import { SpinnerModalComponent } from 'src/app/shared/components/others/spinner-modal/spinner-modal.component';
import { Router } from '@angular/router';


@Component({
  selector: 'app-configura-rlt-page',
  templateUrl: './configura-rlt-page.component.html',
  styleUrls: ['./configura-rlt-page.component.css']
})
export class ConfiguraRltPageComponent implements OnInit {

  configuracionRlt: ConfiguracionRlt = {} as ConfiguracionRlt;
  frecuencia:string[] = ['Diaria', 'Semanal', 'Quincenal', 'Mensual'];
  diasSemana: DiaSemana[] = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo']
  enviosData: TipoEnvio[] = [];
  dialogRefSpinnerInit:any;
  rltReady: boolean = false;

  constructor(public datosConfiguracionAplicacionService: DatosConfiguracionAplicacionService,
              private datosEnviosService: DatosEnviosService,
              private dialog: MatDialog,
              public validacionesFormularioRltService: ValidacionesFormularioRltService,
              private router: Router) {}

  async ngOnInit() {
    this.dialogRefSpinnerInit = this.dialog.open(SpinnerModalComponent);
    await this.getEnviosData();
    this.getConfiguracionRlt();
  }

  async getEnviosData(){
    await this.datosEnviosService.getTipoEnvios([],0);
    this.enviosData = this.datosEnviosService.enviosFiltrados;
  }

  getConfiguracionRlt(){
    this.datosConfiguracionAplicacionService.getConfiguracionRlt().subscribe(
      (response: ConfiguracionRlt) => {
        this.datosConfiguracionAplicacionService.configuracionRlt = response;
        this.datosEnviosService.enviosFiltrados.forEach(x => {
          if (x.idTipoEnvio == this.datosConfiguracionAplicacionService.configuracionRlt.idTipoDosier.toString()) {
            this.datosConfiguracionAplicacionService.nombreDosier = x.nombre;
            // this.datosConfiguracionAplicacionService.envio = x;
          }
          if (x.idTipoEnvio == this.datosConfiguracionAplicacionService.configuracionRlt.idTipoDosier_noFirmados.toString()) {
            this.datosConfiguracionAplicacionService.nombreDosier_noFirmados = x.nombre;
            // this.datosConfiguracionAplicacionService.envio = x;
          }
        });
        // this.datosConfiguracionAplicacionService.iniciaConfiguracionRltForm();
        this.datosConfiguracionAplicacionService.iniciaConfiguracionRltForm();
        this.datosConfiguracionAplicacionService.iniciaConfiguracionRltForm_noFirmados();
        this.dialogRefSpinnerInit.close();
        this.rltReady = true;
      })
  }

  guardaConfiguracionRlt():string | void{
    const formFirmados = this.datosConfiguracionAplicacionService.getFormByTipo('firmados');
    const formNoFirmados = this.datosConfiguracionAplicacionService.getFormByTipo('noFirmados');

    let hasError = false;

    if(formFirmados.invalid){
      formFirmados.markAllAsTouched();
      hasError = true;
    }
    if(formNoFirmados.invalid){
      formNoFirmados.markAllAsTouched();
      hasError = true;
    }
    if(hasError) return;

    let objetoConfiguracionRlt: ConfiguracionRlt;

    let dosierFirmados: TipoEnvio;
    let dosier_noFirmados: TipoEnvio;

    this.enviosData.forEach(x => {
      if(x.nombre == this.datosConfiguracionAplicacionService.getFormByTipo('firmados').controls['dosier'].value){
        dosierFirmados = x;
      }
    })
    this.enviosData.forEach(x => {
      if(x.nombre == this.datosConfiguracionAplicacionService.getFormByTipo('noFirmados').controls['dosier'].value){
        dosier_noFirmados = x;
      }
    })

    objetoConfiguracionRlt = {
      activo: this.datosConfiguracionAplicacionService.getActivo('firmados').value,
      idTipoDosier: (dosierFirmados?.idTipoEnvio)?Number(dosierFirmados.idTipoEnvio):0,
      // idTipoDosierV3: dosierFirmados.idV3TipoEnvio,
      periodicidad: this.datosConfiguracionAplicacionService.getPeriodicidad('firmados').value,
      diaEnvio: this.datosConfiguracionAplicacionService.getDiaEnvio('firmados').value,
      hora: this.datosConfiguracionAplicacionService.getHoraEnvio('firmados').value,
      cadaDia: this.datosConfiguracionAplicacionService.getCadaDia('firmados').value,
      diaMes: this.datosConfiguracionAplicacionService.getDiaMes('firmados').value,
      primerUltimoDia: this.datosConfiguracionAplicacionService.getPrimerUltimoDia('firmados').value,
      tipoDia: this.datosConfiguracionAplicacionService.getTipoDia('firmados').value,
      activo_noFirmados: this.datosConfiguracionAplicacionService.getActivo('noFirmados').value,
      idTipoDosier_noFirmados: (dosier_noFirmados?.idTipoEnvio)?Number(dosier_noFirmados.idTipoEnvio): 0,
      periodicidad_noFirmados: this.datosConfiguracionAplicacionService.getPeriodicidad('noFirmados').value,
      diaEnvio_noFirmados: this.datosConfiguracionAplicacionService.getDiaEnvio('noFirmados').value,
      hora_noFirmados: this.datosConfiguracionAplicacionService.getHoraEnvio('noFirmados').value,
      cadaDia_noFirmados: this.datosConfiguracionAplicacionService.getCadaDia('noFirmados').value,
      diaMes_noFirmados: this.datosConfiguracionAplicacionService.getDiaMes('noFirmados').value,
      primerUltimoDia_noFirmados: this.datosConfiguracionAplicacionService.getPrimerUltimoDia('noFirmados').value,
      tipoDia_noFirmados: this.datosConfiguracionAplicacionService.getTipoDia('noFirmados').value,
      diasRetraso_noFirmados: this.datosConfiguracionAplicacionService.getDiasRetraso('noFirmados').value
    }

    const dialogRefSpinner = this.dialog.open(SpinnerModalComponent);
    this.datosConfiguracionAplicacionService.guardaConfiguracionRlt(objetoConfiguracionRlt).subscribe(
      ok => {
        dialogRefSpinner.close();
        const dialogRef = this.dialog.open(ModalMessageComponent, {
          data: {
            mensaje: 'Configuración del RLT guardada correctamente.',
          },
        });
        dialogRef.afterClosed().subscribe(result => {
          if(result==='OK') this.router.navigate(['/panel/opciones-configuracion']);
        });
      },
      error => {
        dialogRefSpinner.close();
        const dialogRef = this.dialog.open(ModalMessageComponent, {
          data: {
            mensaje: 'Error. La configuración de RLT no se ha guardado.',
            alert:true
          },
        });
        console.error("error", error);
      }
    )
  }

}

